import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WindowService {
  private openedWindows = new BehaviorSubject<any[]>([]);
  private highestZIndex = 3;

  // Observable for components to subscribe to
  windows$ = this.openedWindows.asObservable();

  constructor() {}

  // Method to update the array
  updateWindows(newWindows: any[]) {
    this.openedWindows.next(newWindows);
  }

  // Method to add an item to the array
  addWindow(window: any) {
    const currentArray = this.openedWindows.getValue();
    currentArray.push(window);
    this.openedWindows.next(currentArray);  // Notify subscribers
  }

  getHighestZIndex() {
    return this.highestZIndex;
  }

  incrementHighestZIndex() {
    this.highestZIndex++;
  }
}
